import getConnectionAllies from "../components/Allies/AlliesConnect";
import { eventTracker } from "../components/EventTracker/EventTracker";
import { SOURCE_NAME } from "../constants/sources";

/**
 * Redirige al usuario a un curso de un aliado externo
 * @param {Object} params - Parámetros de la función
 * @param {string} params.person_id - ID de la persona
 * @param {string} params.email - Email del usuario
 * @param {string} params.ou - Unidad organizacional
 * @param {string} params.course_url - URL del curso
 * @param {number} params.source_id - ID de la fuente/aliado
 * @param {string} params.course_url_neo - URL del curso en NEO
 * @param {number} params.course_id - ID del curso
 * @param {number} params.company_id - ID de la compañía
 * @param {string} params.course_name - Nombre del curso
 * @param {Function} setLoad - Función para controlar el estado de carga (opcional)
 * @param {string} eventSource - Fuente del evento para tracking (default: 'clases')
 * @returns {Promise<void>}
 */
async function goToCourseOfAlly({
    person_id,
    email,
    ou,
    course_url,
    source_id,
    course_url_neo,
    course_id,
    company_id,
    course_name,
    setLoad,
    eventSource = 'clases'
}) {
    if (setLoad) setLoad(true);

    const body = {
        person_id,
        email,
        ou,
        course_url,
        source_id,
        course_url_neo,
        course_id,
        company_id,
        course_name,
    };

    console.log('body de redireccion: ', body)

    const win = window.open(
        window.location.protocol + '//' + window.location.host + '/redireccionando/' + source_id,
        "_blank"
    );

    const urlRespuesta = await getConnectionAllies(body);
    
    setTimeout(() => {
        win.focus();
        win.location.replace(urlRespuesta);
    }, 3000);

    const eventData = {
        source: eventSource,
        courseID: course_id,
        marcaCurso: company_id || SOURCE_NAME[source_id] || source_id
    };
    eventTracker('continuar_curso', eventData, ['mixpanel']);

    if (setLoad) setLoad(false);
}


function goToDetailCourse(course_id) {
    console.log('Si estoy funcionando')
    return (history) => {
        const path = '/cursos/' + course_id;
        history.push(path);
    };
}

export {goToCourseOfAlly, goToDetailCourse}